module.exports = __webpack_public_path__ + "img/GENERIC.6d978c7b.svg";